/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import EmployeeUserManagementContainer from './employee/container/EmployeeUserManagementContainer';

function UserManagementContainer({ match }) {
  return (
    <div className="module-inner">
      <div className="module-inner-title">User Management</div>
      <Switch>
        <Route
          exact
          path={`${match.path}`}
          render={() => <Redirect to={`${match.path}/employees`} />}
        />

        <Route
          path={`${match.path}/employees`}
          component={EmployeeUserManagementContainer}
        />
      </Switch>
    </div>
  );
}

UserManagementContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(UserManagementContainer);
